// extracted by mini-css-extract-plugin
export var quantityInput = "_ic-0";